module.exports = __webpack_public_path__ + "static/media/opensans-regular.01c6d4e7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-regular.woff
// module id = 290
// module chunks = 0